import React from 'react';
import { InvoiceSummaryBucketsContainer } from '@finance-hub/domain/invoicing/containers/invoice-summary-buckets-container';
import { UnpaidInvoicesTableContainer } from '@finance-hub/domain/invoicing/containers/unpaid-invoices-table-container';
import {
  useLayoutGutter,
  usePageLayoutHeaderInset,
  View,
} from '@usepepper/sprout-kit-ui';

export const InvoicesContent: React.FC = () => {
  const gutter = useLayoutGutter();
  const headerInset = usePageLayoutHeaderInset();

  return (
    <View
      flex={1}
      gap="$16"
      marginTop={headerInset}
      paddingTop="$24"
      width="100%"
    >
      <View paddingHorizontal={gutter}>
        <InvoiceSummaryBucketsContainer />
      </View>
      <UnpaidInvoicesTableContainer />
    </View>
  );
};
